import Icon from '@/components/snippets/icon/icon'
import { FilterItem } from 'libs/athos/components/collection/filters/FilterItem'
import { FilterSelected } from 'libs/athos/components/collection/filters/FilterSelected'
import { FilterSkeleton } from 'libs/athos/components/collection/filters/FilterSkeleton'
import { FilterSort } from 'libs/athos/components/collection/filters/FilterSort'
import { useFilters } from 'libs/athos/hooks/useFilters'
import { useAthosContext } from 'libs/athos/fetchers/provider'

// Filters open by default on desktop (see the mount effect in FiltersProvider,
// useFilters.js). On mobile they stay closed until the shopper opens them via
// the filter-toggle or the toolbar "Filters" button, both of which dispatch
// `filters.open`.
export function FilterDrawer({ id = 'filters' }) {
  const {
    handleClearFilters,
    handleToggleFilter,
    handleRemoveFilter,
    initialFilters,
    activeFilters,
    fetchedFilters,
    isLoading,
    isDesktopDefaultOpen
  } = useFilters()

  const { results } = useAthosContext()
  const totalResults = results?.pagination?.totalResults || 0

  return (
    <x-modal
      className="group/filters lg-max:z-60 border-r border-r-borders-default"
      style={{
        '--above-toolbar-height': '0px'
      }}
      data-id={id}
      data-ui={isDesktopDefaultOpen ? 'visible' : undefined}
    >
      <div className="flex flex-col fixed lg:sticky top-0 lg:top-[calc(var(--height-header-adapt)+60px)] lg:h-[calc(100dvh-var(--height-header-adapt)-60px)] overflow-hidden items-end left-0 w-full lg:w-0 group-data-visible/filters:lg:w-grid-1/4-window group-data-visible/filters:xl:w-grid-1/5-window group-data-visible/filters:xxxl:w-grid-1/6-window h-view pointer-events-none group-data-visible/filters:pointer-events-auto lg-max:z-60 transition-all">
        <div
          className="flex flex-col w-full lg:w-grid-1/4-window xl:w-grid-1/5-window xxxl:w-grid-1/6-window h-full lg-max:max-w-[335px] lg-max:bg-secondary translate-x-screen-margin group-data-visible/filters:translate-x-0 z-2 transition-all"
        >
          <div class="shrink-0 flex flex-col py-0.5 lg:hidden">
            <div className="flex gap-x-gutter items-center justify-between w-full lg-max:h-[52px] lg-max:px-margin lg-max:border-b lg-max:border-borders-default">
              <h2 className="heading-m font-serif">Filter Products</h2>
              {/* ({activeFilters.size}) */}
              <button
                className="lg:hidden size-[13px] children:size-full"
                data-modal-parent={id}
                data-modal-role="close"
                aria-label="Close Filters"
              >
                <Icon id="close" />
              </button>
            </div>
            <FilterSelected activeFilters={activeFilters} onRemove={handleRemoveFilter} onClear={handleClearFilters} />
          </div>
          <div className="grow flex flex-col min-h-0 overflow-y-scroll no-scrollbar pb-4">
            <FilterSort />
            {isLoading && initialFilters.length === 0 ? (
              <FilterSkeleton />
            ) : initialFilters.length > 0 ? (
              initialFilters.map((filter) => (
                <FilterItem
                  filter={filter}
                  onFilter={handleToggleFilter}
                  onRemove={handleRemoveFilter}
                  fetchedFilters={fetchedFilters}
                  activeFilters={activeFilters}
                  key={filter.field}
                />
              ))
            ) : (
              <div className="lg-max:px-margin px-1.5 py-1">
              <p className="lg-max:px-margin py-1 text-type-black-secondary heading-xs">No filters available</p>
              </div>
            )}
          </div>
          <div className="shrink-0 flex lg:hidden gap-x-gutter w-full px-margin py-1.25 bg-secondary border-t border-t-borders-default">
            {activeFilters.size > 0 && (
              <button
              key="cancel"
              className="btn btn-primary btn-border btn-m"
              onClick={handleClearFilters}
              aria-label="Clear Filters"
            >
              <span>
                Cancel
              </span>
            </button>
            )}
            <button
              key="show-results"
              className="grow btn btn-primary btn-fill btn-m"
              data-modal-parent={id}
              data-modal-role="close"
              aria-label="View Results"
            >
              <span>
                Show {totalResults} Results
              </span>
            </button>
          </div>
        </div>
        <button
            class="lg:hidden fixed inset-tl size-full bg-type-black-primary/60 opacity-0 group-data-visible/filters:opacity-100 pointer-events-none group-data-visible/filters:pointer-events-auto cursor-w-resize transition-all"
            data-modal-parent={id}
            data-modal-role="close"
            aria-label="Close Filters"
          >
          </button>
      </div>
    </x-modal>
  )
}
